"use client";

import dynamic from "next/dynamic";

import type { RootNotFoundSheetProps } from "@/components/root-not-found-sheet";

/**
 * The root 404's stylesheets, loaded only when the root 404 renders.
 *
 * The root `not-found.tsx` belongs to the root segment, so a stylesheet it
 * imports is listed for EVERY route, built CMS pages included (design.md D11).
 * A lazy import keeps it off those routes only on the client side:
 * `next/dynamic` called from a server component still lists the imported CSS
 * for the route. From a client component, the CSS is written only by
 * `PreloadChunks` (`next/dist/shared/lib/lazy-dynamic/preload-chunks.js`)
 * while this component renders.
 *
 * `themeCss` is computed server-side by the caller and passed straight
 * through — this keeps the theme compiler itself out of every client bundle.
 */
export const RootNotFoundStyles = dynamic<RootNotFoundSheetProps>(
  () => import("@/components/root-not-found-sheet"),
);
